import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { ISelectOption } from "src/app/models/selectOptions/selectOption.interface";

@Component({
    selector: "app-select-v2",
    templateUrl: "./select-v2.component.html",
    styleUrls: ["./select-v2.component.scss"],
})
export class SelectV2Component implements OnInit, OnDestroy, OnChanges {
    @Input() public options$: BehaviorSubject<ISelectOption[]>;
    @Input() public selectedId?: string;
    @Input() public valid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

    @Input() public disabled = false;

    @Input() public placeHolder = "";
    @Input() public canBeEmpty: boolean;
    @Input() public withoutShowingSelection = false;
    @Input() public noBorder = false;

    @Output() public optionOnSelection = new EventEmitter<ISelectOption | undefined>();

    public optionsVisible = false;
    public optionsById: Map<string, ISelectOption> = new Map<string, ISelectOption>();

    public isFormValid = true;

    private _optionsSubscription?: Subscription;

    ngOnInit(): void {
        this._optionsSubscription = this.options$.subscribe((options) => {
            if (options.length > 0) {
                this._handelSelectedOptionAfterOptionChange(this.options$.value);
            }
        });

        this.valid.subscribe((value) => (this.isFormValid = value));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            "selectedId" in changes &&
            changes["selectedId"].currentValue &&
            changes["selectedId"].previousValue !== changes["selectedId"].currentValue
        ) {
            this._handleSelectedIdOnChange(changes["selectedId"].currentValue as string);
        }
    }

    ngOnDestroy() {
        this._optionsSubscription?.unsubscribe;
    }

    public onSelect(id: string): void {
        this.optionsVisible = false;
        if (id !== this.selectedId) {
            this.optionOnSelection.emit(this.optionsById.get(id));
            return;
        }
        if (id === this.selectedId && this.canBeEmpty) {
            this.clearSelection();
        }
    }

    public clearSelection() {
        this.optionOnSelection.emit(undefined);
    }

    public inputOnClick(): void {
        if (this.disabled) return;

        this.optionsVisible = !this.optionsVisible;
    }

    public onClickOutside() {
        this.optionsVisible = false;
    }

    private _handleSelectedIdOnChange(newId: string) {
        if (this.optionsById.size > 0 && !this.optionsById.has(newId)) {
            this.clearSelection();
        }
    }

    private _handelSelectedOptionAfterOptionChange(newOptions: ISelectOption[]) {
        this.optionsById = new Map<string, ISelectOption>(newOptions.map((option) => [option.id, option]));

        if (this.selectedId != "" && this.selectedId && !this.optionsById.has(this.selectedId)) {
            this.clearSelection();
        }
    }
}
